module.exports = __webpack_public_path__ + "img/四川天府新区金鑫幼儿园.cbf37844.jpg";